<main class="main-content audience-page">
  <section class="audience-container" [class.create-mode]="mode === 'create'">
  <header class="audience-header" *ngIf="mode === 'list'">
    <div>
      <h1>
        {{ 'audiences.title' | translate }}
      </h1>
      <p>{{ 'audiences.subtitle' | translate }}</p>
    </div>
    <button type="button"
            class="primary-btn"
            (click)="startCreate()"
            [disabled]="!canCreateAudience">
      {{ 'audiences.actions.create' | translate }}
    </button>
  </header>


  <app-audience-extractions-chart
    *ngIf="mode === 'list' && showAdvancedInsights">
  </app-audience-extractions-chart>

  <div class="audience-toolbar" *ngIf="mode === 'list'">
    <div class="toolbar-summary">
          <div class="status-pills">
            <ng-container *ngFor="let status of availableStatuses">
              <button
                *ngIf="status.id !== 'billable' || hasGlobalDataAccess"
                type="button"
                class="status-pill"
                [class.is-active]="statusFilters[status.id]"
                [style.--status-color]="statusColors[status.id]"
                [attr.aria-pressed]="statusFilters[status.id]"
                [attr.title]="status.labelKey | translate"
                (click)="toggleStatusFilter(status.id)">
                <span class="status-pill__count" aria-hidden="true">{{ statusCounts[status.id] || 0 }}</span>
                <span class="status-pill__label">{{ status.labelKey | translate }}</span>
              </button>
            </ng-container>
          </div>
        </div>
        <div class="toolbar-controls">
          <button type="button"
                  class="ghost-btn compact owner-filter-trigger experimental-marker"
                  *ngIf="isOwnerFilterEnabled"
                  [class.is-active]="selectedOwnerIds.size > 0"
                  [attr.title]="'experimentalFeatures.markerTooltip' | translate"
                  (click)="toggleOwnerFilterPanel($event)"
                  [attr.aria-expanded]="ownerFilterOpen">
            {{ ownerFilterButtonLabel }} ▾
          </button>
          <button type="button"
                  class="ghost-btn compact extraction-date-filter-trigger experimental-marker"
                  *ngIf="isExtractionDateFilterEnabled"
                  [class.is-active]="!!selectedExtractionDate"
                  [attr.title]="'experimentalFeatures.markerTooltip' | translate"
                  (click)="toggleExtractionDateFilterPanel($event)"
                  [attr.aria-expanded]="extractionDateFilterOpen">
            {{ extractionDateButtonLabel }} ▾
          </button>
          <label class="search-field">
        <input type="search"
               [value]="searchTerm"
               (input)="onSearch($event.target.value)"
               [placeholder]="'audiences.toolbar.searchPlaceholder' | translate"
               aria-label="{{ 'audiences.toolbar.searchPlaceholder' | translate }}">
      </label>
    </div>
  </div>

  <div class="modal-backdrop" *ngIf="exportModalOpen">
    <div class="modal-card confirmation-modal surface-card" role="dialog" aria-modal="true">
      <header class="modal-header">
        <div>
          <h3>{{ 'audiences.actions.quick.activate' | translate }}</h3>
          <p>{{ 'audiences.actions.exportConfirmMessage' | translate:{ name: exportModalTarget?.name } }}</p>
        </div>
        <button type="button" class="ghost-btn compact" aria-label="{{ 'audiences.actions.cancel' | translate }}" (click)="closeExportModal()">×</button>
      </header>
      <footer class="modal-actions">
        <button type="button" class="ghost-btn" (click)="closeExportModal()">
          {{ 'audiences.actions.cancel' | translate }}
        </button>
        <button type="button"
                class="primary-btn"
                (click)="performExport()"
                [disabled]="!canManageAudienceActions || exportingAudienceId === exportModalTarget?.id">
          {{ exportingAudienceId === exportModalTarget?.id
              ? ('audiences.actions.processing' | translate)
              : ('audiences.actions.confirmExport' | translate) }}
        </button>
      </footer>
    </div>
  </div>

  <div class="modal-backdrop" *ngIf="createExitConfirmOpen">
    <div class="modal-card confirmation-modal surface-card" role="dialog" aria-modal="true">
      <header class="modal-header">
        <div>
          <h3>{{ 'audiences.create.leaveConfirm.title' | translate }}</h3>
        </div>
        <button type="button"
                class="ghost-btn compact"
                aria-label="{{ 'audiences.actions.cancel' | translate }}"
                (click)="cancelCreateExit()">×</button>
      </header>
      <footer class="modal-actions">
        <button type="button" class="ghost-btn" (click)="cancelCreateExit()">
          {{ 'audiences.create.leaveConfirm.cancel' | translate }}
        </button>
        <button type="button" class="primary-btn" (click)="confirmCreateExit()">
          {{ 'audiences.create.leaveConfirm.confirm' | translate }}
        </button>
      </footer>
    </div>
  </div>

  <div class="modal-backdrop" *ngIf="sseForceExitOpen">
    <div class="modal-card confirmation-modal surface-card" role="dialog" aria-modal="true">
      <header class="modal-header">
        <div>
          <h3>{{ (sseForceExitReason === 'deleted'
                    ? 'audiences.create.remoteChange.titleDeleted'
                    : 'audiences.create.remoteChange.titleUpdated') | translate }}</h3>
        </div>
      </header>
      <p class="modal-body">
        {{ (sseForceExitReason === 'deleted'
              ? 'audiences.create.remoteChange.bodyDeleted'
              : 'audiences.create.remoteChange.bodyUpdated') | translate }}
      </p>
      <footer class="modal-actions">
        <button type="button" class="primary-btn" (click)="onSseForceExitConfirm()">
          {{ 'audiences.actions.cancel' | translate }}
        </button>
      </footer>
    </div>
  </div>

  <app-destination-activation-modal
    *ngIf="destinationModalOpen"
    [audienceId]="destinationModalTarget?.id || null"
    [audienceName]="destinationModalTarget?.name || null"
    [entityName]="selectedEntityName"
(close)="closeDestinationModal()"
    (activated)="handleDestinationActivated()">
  </app-destination-activation-modal>

  <app-activation-edit-modal
    *ngIf="activationEditTarget"
    [target]="activationEditTarget"
    [audienceName]="selectedAudience?.name || null"
    (close)="closeActivationEdit()"
    (saved)="handleActivationEdited()">
  </app-activation-edit-modal>

  <section class="audience-layout" *ngIf="mode === 'list'">
    <div class="audience-panel surface-card">
      <div class="audience-table-header">
        <span>{{ 'audiences.table.status' | translate }}</span>
        <span class="sortable name-header"
              role="button"
              tabindex="0"
              (click)="toggleNameSort()"
              (keydown.enter)="toggleNameSort()">
          {{ 'audiences.table.name' | translate }}
          <small *ngIf="sortColumn === 'name'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</small>
        </span>
        <span class="sortable"
              role="button"
              tabindex="0"
              (click)="toggleVolumeSort()"
              (keydown.enter)="toggleVolumeSort()">
          {{ 'audiences.table.volume' | translate }}
          <small *ngIf="sortColumn === 'volume'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</small>
        </span>
        <span></span>
      </div>

      <div class="audience-list">
        <p class="list-status" *ngIf="isLoading">{{ 'audiences.list.loading' | translate }}</p>
        <p class="list-status error" *ngIf="!isLoading && loadingError">{{ loadingError }}</p>
        <ng-container *ngFor="let audience of paginatedAudiences">
          <div class="audience-row"
              role="button"
              tabindex="0"
              [class.selected]="selectedAudience?.id === audience.id"
              (click)="selectAudience(audience)"
              (keydown.enter)="selectAudience(audience)">
            <span class="status">
              <span
                class="status-indicator"
                [style.background-color]="statusColors[audience.status]"></span>
            </span>
            <span class="name" [title]="audience.name">
              <span class="name-text">{{ audience.name }}</span>
              <span class="tnc-badge" *ngIf="isTncAudience(audience)">{{ getTncBadgeLabel(audience) }}</span>
              <span class="management-badge" *ngIf="shouldShowUnmanageableAudienceBadge(audience)">{{ 'audiences.badge.obsoleteFilters' | translate }}</span>
            </span>
            <span class="volume">{{ audience.volume }}</span>
            <div class="actions" *ngIf="hasAnyActions(audience)">
              <button type="button"
                      class="action-trigger"
                      [class.loading]="preparingAudienceId === audience.id"
                      aria-haspopup="menu"
                      [attr.aria-expanded]="activeActionMenuId === audience.id"
                      aria-label="{{ 'audiences.actions.menuTitle' | translate }}"
                      (click)="toggleActionsMenu(audience, $event)"
                      [disabled]="(audience.status !== 'error' && (!canManageAudienceActions || isAudienceQuickActionsDisabled(audience))) || preparingAudienceId === audience.id">
                <svg *ngIf="preparingAudienceId !== audience.id" viewBox="0 0 20 20" role="presentation" aria-hidden="true">
                  <circle cx="10" cy="4" r="1.5" />
                  <circle cx="10" cy="10" r="1.5" />
                  <circle cx="10" cy="16" r="1.5" />
                </svg>
                <svg *ngIf="preparingAudienceId === audience.id" class="spinner" viewBox="0 0 24 24" role="presentation" aria-hidden="true">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none" stroke-dasharray="32" stroke-dashoffset="32">
                    <animate attributeName="stroke-dashoffset" dur="1s" values="32;0" repeatCount="indefinite" />
                  </circle>
                </svg>
              </button>
            </div>
          </div>
        </ng-container>
        <div class="pagination-controls" *ngIf="!isLoading && filteredAudiences.length">
          <div class="page-size">
            <label>{{ 'audiences.pagination.rowsPerPage' | translate }}</label>
            <select [value]="pageSize" (change)="changePageSize($event)">
              <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
            </select>
          </div>
          <div class="page-navigation">
            <button type="button"
                    class="ghost-btn"
                    (click)="goToPage(currentPage - 1)"
                    [disabled]="currentPage === 0">
              ‹
            </button>
            <span class="page-info">
              {{ 'audiences.pagination.page' | translate:{ current: currentPage + 1, total: totalPages } }}
            </span>
            <button type="button"
                    class="ghost-btn"
                    (click)="goToPage(currentPage + 1)"
                    [disabled]="currentPage + 1 >= totalPages">
              ›
            </button>
        </div>
      </div>

        <ng-container *ngIf="activeActionAudience as actionAudience">
          <div class="audience-action-menu"
               [class.audience-action-menu--above]="actionMenuPlacement === 'above'"
               role="menu"
               [style.top.px]="actionMenuPosition.top"
               [style.left.px]="actionMenuPosition.left"
               [style.--audience-action-arrow-left]="actionMenuArrowOffset + 'px'">
            <div class="audience-action-menu__label">{{ 'audiences.actions.menuTitle' | translate }}</div>
            <!-- Error status: restricted menu -->
            <button type="button"
                    *ngIf="actionAudience.status === 'error'"
                    class="audience-action-item"
                    (click)="reportAudienceError(actionAudience, $event)"
                    [disabled]="reportingErrorAudienceId === actionAudience.id">
              <span class="action-icon action-icon--warning" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <path d="M10 2L1 17h18L10 2z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" fill="none"/>
                  <path d="M10 8v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                  <circle cx="10" cy="14.5" r="0.75" fill="currentColor"/>
                </svg>
              </span>
              <span>
                {{ reportingErrorAudienceId === actionAudience.id
                    ? ('audiences.actions.quick.processing' | translate)
                    : ('audiences.actions.quick.reportError' | translate) }}
              </span>
            </button>
            <!-- Normal menu (hidden when status is error) -->
            <!-- Approve action for draft audiences -->
            <button type="button"
                    *ngIf="actionAudience.status !== 'error' && actionAudience.status === 'draft' && canManageAudienceDefinition(actionAudience)"
                    class="audience-action-item"
                    (click)="editAudience(actionAudience, $event)"
                    [disabled]="!canManageAudienceActions">
              <span class="action-icon action-icon--check" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              <span>{{ 'audiences.actions.quick.approve' | translate }}</span>
            </button>
            <!-- Edit action for non-draft audiences -->
            <button type="button"
                    *ngIf="actionAudience.status !== 'error' && actionAudience.status !== 'draft' && canManageAudienceDefinition(actionAudience)"
                    class="audience-action-item"
                    (click)="editAudience(actionAudience, $event)"
                    [disabled]="!canManageAudienceActions">
              <span class="action-icon action-icon--edit" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <path d="M3 14.5V17h2.5L15.4 7.1l-2.5-2.5L3 14.5z" />
                  <path d="M12.2 4.1l2.5 2.5 1.4-1.4c.4-.4.4-1 0-1.4L14 2.2c-.4-.4-1-.4-1.4 0l-1.4 1.9z" />
                </svg>
              </span>
              <span>{{ 'audiences.actions.quick.edit' | translate }}</span>
            </button>
            <button type="button"
                    *ngIf="actionAudience.status !== 'error' && actionAudience.status !== 'draft'"
                    class="audience-action-item"
                    (click)="cloneAudience(actionAudience, $event)"
                    [disabled]="!canManageAudienceActions">
              <span class="action-icon action-icon--duplicate" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <rect x="5" y="5" width="10" height="10" rx="2" />
                  <rect x="3" y="3" width="10" height="10" rx="2" />
                </svg>
              </span>
              <span>{{ 'audiences.actions.quick.clone' | translate }}</span>
            </button>
            <button type="button"
                    *ngIf="actionAudience.status !== 'error' && (hasGlobalDataAccess || canManageAudienceDefinition(actionAudience)) && actionAudience.status !== 'draft'"
                    class="audience-action-item"
                    (click)="confirmToggleStatus(actionAudience, $event)"
                    [disabled]="!canManageAudienceActions || statusUpdatingId === actionAudience.id">
              <span class="action-icon action-icon--pause" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <rect x="6" y="4" width="2.5" height="12" rx="1" />
                  <rect x="11.5" y="4" width="2.5" height="12" rx="1" />
                </svg>
              </span>
              <span>
                {{ statusUpdatingId === actionAudience.id
                    ? ('audiences.actions.quick.processing' | translate)
                    : actionAudience.status === 'active'
                    ? ('audiences.actions.quick.pause' | translate)
                    : ('audiences.actions.quick.resume' | translate) }}
              </span>
            </button>
            <button type="button"
                    *ngIf="actionAudience.status !== 'error' && hasGlobalDataAccess && actionAudience.status !== 'draft'"
                    class="audience-action-item"
                    (click)="confirmExport(actionAudience, $event)"
                    [disabled]="!canManageAudienceActions || exportingAudienceId === actionAudience.id">
              <span class="action-icon action-icon--refresh" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <path d="M4 11a6 6 0 0 0 10 4" />
                  <path d="M16 9a6 6 0 0 0-10-4" />
                  <path d="M4 15v-4h4" />
                  <path d="M12 5h4v4" />
                </svg>
              </span>
              <span>
                {{ exportingAudienceId === actionAudience.id
                    ? ('audiences.actions.quick.processing' | translate)
                    : ('audiences.actions.quick.activate' | translate) }}
              </span>
            </button>
            <button type="button"
                    *ngIf="actionAudience.status !== 'error' && actionAudience.status !== 'draft' && canExportAudience(actionAudience)"
                    class="audience-action-item"
                    (click)="openDestinationModal(actionAudience, $event)">
              <span class="action-icon action-icon--destination" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <path d="M3 10h14" />
                  <path d="M10 3l7 7-7 7" />
                </svg>
              </span>
              <span>{{ 'audiences.actions.quick.export' | translate }}</span>
            </button>
            <button type="button"
                    *ngIf="actionAudience.status !== 'error' && actionAudience.status !== 'draft'"
                    class="audience-action-item"
                    (click)="checkAudienceOverlap(actionAudience, $event)"
                    [disabled]="overlapLoadingId === actionAudience.id">
              <span class="action-icon action-icon--overlap" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <circle cx="8" cy="10" r="4" />
                  <circle cx="12" cy="10" r="4" />
                </svg>
              </span>
              <span>
                {{ overlapLoadingId === actionAudience.id
                    ? ('audiences.actions.quick.processing' | translate)
                    : ('audiences.actions.quick.overlap' | translate) }}
              </span>
            </button>
            <button type="button"
                    *ngIf="hasGlobalDataAccess || (actionAudience.status !== 'error' && canEditAudience(actionAudience))"
                    class="audience-action-item danger"
                    (click)="confirmDelete(actionAudience, $event)"
                    [disabled]="!canManageAudienceActions || deletingAudienceId === actionAudience.id">
              <span class="action-icon action-icon--delete" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <path d="M6 6h8l-.8 10.5H6.8L6 6z" />
                  <path d="M4 5h12" />
                  <path d="M8 5V3h4v2" />
                </svg>
              </span>
              <span>
                {{ deletingAudienceId === actionAudience.id
                    ? ('audiences.actions.quick.processing' | translate)
                    : ('audiences.actions.quick.delete' | translate) }}
              </span>
            </button>
          </div>
        </ng-container>
        <p *ngIf="!isLoading && !loadingError && !filteredAudiences.length" class="empty-destination">
          {{ 'audiences.list.empty' | translate }}
        </p>
      </div>
    </div>

    <div class="audience-details surface-card" #detailsPanel>
      <ng-container *ngIf="selectedAudience; else emptyState">
        <header class="detail-header">
          <div>
            <h2 [title]="selectedAudience.name">
              {{ selectedAudience.name }}
            </h2>
            <p>{{ 'audiences.details.meta' | translate:{ schedule: selectedAudience.schedule } }}</p>
          </div>
        </header>

        <div class="detail-grid">
          <div class="detail-field">
            <label>{{ 'audiences.details.id' | translate }}</label>
            <div class="value with-copy">
              <span class="audience-id" [title]="selectedAudience.id">{{ selectedAudience.id }}</span>
              <button type="button"
                      class="ghost-btn copy-btn"
                      (click)="copyAudienceValue(selectedAudience.id)"
                      [attr.aria-label]="'audiences.details.copy' | translate">
                <span aria-hidden="true">
                  <svg viewBox="0 0 20 20" focusable="false">
                    <rect x="6" y="2" width="10" height="12" rx="1.5" ry="1.5"></rect>
                    <path d="M4 6h-1.5a1.5 1.5 0 0 0-1.5 1.5v9A1.5 1.5 0 0 0 2.5 18h9a1.5 1.5 0 0 0 1.5-1.5V15"></path>
                  </svg>
                </span>
                <span class="sr-only">{{ 'audiences.details.copy' | translate }}</span>
              </button>
            </div>
          </div>
          <div class="detail-field">
            <label>{{ 'audiences.details.owner' | translate }}</label>
            <span class="value">{{ getAudienceOwner(selectedAudience) }}</span>
          </div>
          <div class="detail-field" *ngIf="!selectedAudience.isPublic">
            <label>{{ 'audiences.details.createdAt' | translate }}</label>
            <span class="value">{{ selectedAudience.createdAt }}</span>
          </div>
          <div class="detail-field" *ngIf="!selectedAudience.isPublic">
            <label>{{ 'audiences.details.endDate' | translate }}</label>
            <span class="value">{{ selectedAudience.endDate }}</span>
          </div>
          <div class="detail-field">
            <label>{{ 'audiences.details.lastExtraction' | translate }}</label>
            <span class="value">{{ selectedAudience.lastExtraction }}</span>
          </div>
          <div class="detail-field">
            <label>{{ 'audiences.details.nextExtraction' | translate }}</label>
            <span class="value">{{ selectedAudience.nextExtraction }}</span>
          </div>
<!-- Commentato per togliere il valore schedule sopra i dettagli delle audience attive-->
<!--          <div class="detail-field">-->
<!--            <label>{{ 'audiences.details.schedule' | translate }}</label>-->
<!--            <span class="value">{{ selectedAudience.schedule }}</span>-->
<!--          </div>-->
        </div>

        <!-- Additional Info avanzato (tab Details/Volumes/Sociodemo/Tags/Changelog) — solo admin_dashboard.all -->
        <app-audience-additional-info
          *ngIf="showAdvancedInsights"
          [audience]="selectedAudience"
          [ownerLabel]="getAudienceOwner(selectedAudience)">
        </app-audience-additional-info>

        <!-- Export attivi -->
        <div class="destinations" *ngIf="activeDestinations.length">
          <h3>{{ 'audiences.destinations.activeTitle' | translate }}</h3>
          <div class="destination-card destination-card--active surface-card"
               *ngFor="let group of activeDestinationsByType; trackBy: trackDestinationGroup">
            <div class="destination-type-header">
              <strong>{{ group.typeName }}</strong>
              @if (getDestinationTypeIconPath(group.typeId); as iconPath) {
                <img class="destination-type-logo" [src]="iconPath" [alt]="group.typeName"
                     (error)="onDestinationLogoError(group.typeId)">
              } @else {
                <span class="destination-type-logo destination-type-logo--fallback">{{ group.typeName.charAt(0).toUpperCase() }}</span>
              }
            </div>
            <div class="destination-list">
              <div class="destination-item"
                   *ngFor="let destination of group.destinations; trackBy: trackDestination">
                <div class="destination-item__header">
                  <span class="destination-item__name" *ngIf="hasDestinationAccess(destination)">{{ destination.name }}</span>
                  <span class="destination-item__name" *ngIf="!hasDestinationAccess(destination)">
                    {{ destination.destinationTypeName }}
                    <span class="destination-item__owner">{{ 'audiences.destinations.entity' | translate }}: {{ getDestinationOwnerLabel(destination) }}</span>
                  </span>
                  <span class="destination-item__actions">
                    <button type="button"
                            class="destination-action-trigger"
                            aria-haspopup="menu"
                            [attr.aria-expanded]="activeDestinationActionMenuId === destination.id"
                            aria-label="{{ 'audiences.destinations.menuTitle' | translate }}"
                            (click)="toggleDestinationActionsMenu(destination, $event)">
                      <svg viewBox="0 0 20 20" role="presentation" aria-hidden="true">
                        <circle cx="10" cy="4" r="1.5" />
                        <circle cx="10" cy="10" r="1.5" />
                        <circle cx="10" cy="16" r="1.5" />
                      </svg>
                    </button>
                  </span>
                </div>
                <div class="destination-item__metrics">
                  <div class="destination-metric destination-metric--wide">
                    <label>{{ 'audiences.destinations.externalSegmentId' | translate }}</label>
                    <span class="destination-metric__value destination-metric__value--copy"
                          [class.is-copied]="isExternalSegmentIdCopied(destination)"
                          [title]="isExternalSegmentIdCopied(destination) ? ('audiences.destinations.copied' | translate) : destination.externalSegmentId"
                          (click)="copyExternalSegmentId(destination)">{{ destination.externalSegmentId }}</span>
                  </div>
                  <div class="destination-metric">
                    <label>{{ 'audiences.destinations.volume' | translate }}</label>
                    <span class="destination-metric__value">{{ destination.volume }}</span>
                  </div>
                  <div class="destination-metric">
                    <label>{{ 'audiences.destinations.nextPush' | translate }}</label>
                    <span class="destination-metric__value">{{ destination.nextPushDate }}</span>
                  </div>
                  <div class="destination-metric">
                    <label>{{ 'audiences.destinations.lastPush' | translate }}</label>
                    <span class="destination-metric__value">{{ destination.lastPushDate }}</span>
                  </div>
                  <div class="destination-metric destination-metric--wide" *ngIf="destination.description">
                    <label>{{ 'audiences.destinations.note' | translate }}</label>
                    <span class="destination-metric__value">{{ destination.description }}</span>
                  </div>
                  <div class="destination-metric destination-metric--chart" *ngIf="showAdvancedInsights">
                    <label>{{ 'audiences.destinations.pushTrend' | translate }}</label>
                    <app-audience-activation-push-chart [activationId]="destination.id"></app-audience-activation-push-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Export in pausa -->
        <div class="destinations-section" *ngIf="stoppedDestinations.length">
          <button type="button" class="ghost-btn" *ngIf="!showStoppedDestinations" (click)="showStoppedDestinations = true">
            {{ 'audiences.destinations.showStopped' | translate:{ count: stoppedDestinations.length } }}
          </button>
          <button type="button" class="ghost-btn" *ngIf="showStoppedDestinations" (click)="showStoppedDestinations = false">
            {{ 'audiences.destinations.hideStopped' | translate }}
          </button>
        </div>

        <div class="destinations destinations-section" *ngIf="showStoppedDestinations && stoppedDestinations.length">
          <h3>{{ 'audiences.destinations.stoppedTitle' | translate }}</h3>
          <div class="destination-card surface-card destination-card--stopped"
               *ngFor="let group of stoppedDestinationsByType; trackBy: trackDestinationGroup">
            <div class="destination-type-header">
              <strong>{{ group.typeName }}</strong>
              @if (getDestinationTypeIconPath(group.typeId); as iconPath) {
                <img class="destination-type-logo" [src]="iconPath" [alt]="group.typeName"
                     (error)="onDestinationLogoError(group.typeId)">
              } @else {
                <span class="destination-type-logo destination-type-logo--fallback">{{ group.typeName.charAt(0).toUpperCase() }}</span>
              }
            </div>
            <div class="destination-list">
              <div class="destination-item"
                   *ngFor="let destination of group.destinations; trackBy: trackDestination">
                <div class="destination-item__header">
                  <span class="destination-item__name" *ngIf="hasDestinationAccess(destination)">{{ destination.name }}</span>
                  <span class="destination-item__name" *ngIf="!hasDestinationAccess(destination)">
                    {{ destination.destinationTypeName }}
                    <span class="destination-item__owner">{{ 'audiences.destinations.entity' | translate }}: {{ getDestinationOwnerLabel(destination) }}</span>
                  </span>
                  <span class="destination-item__actions">
                    <button type="button"
                            class="destination-action-trigger"
                            aria-haspopup="menu"
                            [attr.aria-expanded]="activeDestinationActionMenuId === destination.id"
                            aria-label="{{ 'audiences.destinations.menuTitle' | translate }}"
                            (click)="toggleDestinationActionsMenu(destination, $event)">
                      <svg viewBox="0 0 20 20" role="presentation" aria-hidden="true">
                        <circle cx="10" cy="4" r="1.5" />
                        <circle cx="10" cy="10" r="1.5" />
                        <circle cx="10" cy="16" r="1.5" />
                      </svg>
                    </button>
                  </span>
                </div>
                <div class="destination-item__metrics">
                  <div class="destination-metric destination-metric--wide">
                    <label>{{ 'audiences.destinations.externalSegmentId' | translate }}</label>
                    <span class="destination-metric__value destination-metric__value--copy"
                          [class.is-copied]="isExternalSegmentIdCopied(destination)"
                          [title]="isExternalSegmentIdCopied(destination) ? ('audiences.destinations.copied' | translate) : destination.externalSegmentId"
                          (click)="copyExternalSegmentId(destination)">{{ destination.externalSegmentId }}</span>
                  </div>
                  <div class="destination-metric">
                    <label>{{ 'audiences.destinations.volume' | translate }}</label>
                    <span class="destination-metric__value">{{ destination.volume }}</span>
                  </div>
                  <div class="destination-metric">
                    <label>{{ 'audiences.destinations.nextPush' | translate }}</label>
                    <span class="destination-metric__value">{{ destination.nextPushDate }}</span>
                  </div>
                  <div class="destination-metric">
                    <label>{{ 'audiences.destinations.lastPush' | translate }}</label>
                    <span class="destination-metric__value">{{ destination.lastPushDate }}</span>
                  </div>
                  <div class="destination-metric destination-metric--wide" *ngIf="destination.description">
                    <label>{{ 'audiences.destinations.note' | translate }}</label>
                    <span class="destination-metric__value">{{ destination.description }}</span>
                  </div>
                  <div class="destination-metric destination-metric--chart" *ngIf="showAdvancedInsights">
                    <label>{{ 'audiences.destinations.pushTrend' | translate }}</label>
                    <app-audience-activation-push-chart [activationId]="destination.id"></app-audience-activation-push-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="activeDestinationActionMenu as actionDestination">
          <div class="destination-action-menu"
               [class.destination-action-menu--above]="destinationActionMenuPlacement === 'above'"
               role="menu"
               [style.top.px]="destinationActionMenuPosition.top"
               [style.left.px]="destinationActionMenuPosition.left"
               [style.--audience-action-arrow-left]="destinationActionMenuArrowOffset + 'px'">
            <div class="audience-action-menu__label">{{ 'audiences.destinations.menuTitle' | translate }}</div>
            <button type="button"
                    class="audience-action-item"
                    (click)="toggleDestinationStatus(actionDestination)"
                    [disabled]="activationStatusUpdatingId === actionDestination.id">
              <span class="action-icon action-icon--pause" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <rect x="6" y="4" width="2.5" height="12" rx="1" />
                  <rect x="11.5" y="4" width="2.5" height="12" rx="1" />
                </svg>
              </span>
              <span>
                {{ activationStatusUpdatingId === actionDestination.id
                    ? ('audiences.actions.quick.processing' | translate)
                    : (actionDestination.status || '').toLowerCase() === 'active'
                    ? ('audiences.destinations.pause' | translate)
                    : ('audiences.destinations.resume' | translate) }}
              </span>
            </button>
            <button type="button"
                    *ngIf="hasDestinationAccess(actionDestination)"
                    class="audience-action-item"
                    (click)="openActivationEdit(actionDestination)">
              <span class="action-icon action-icon--edit" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <path d="M3 14.5V17h2.5L15.4 7.1l-2.5-2.5L3 14.5z" />
                  <path d="M12.2 4.1l2.5 2.5 1.4-1.4c.4-.4.4-1 0-1.4L14 2.2c-.4-.4-1-.4-1.4 0l-1.4 1.9z" />
                </svg>
              </span>
              <span>{{ 'audiences.destinations.edit' | translate }}</span>
            </button>
            <button type="button"
                    *ngIf="hasGlobalDataAccess"
                    class="audience-action-item danger"
                    (click)="confirmForcePush(actionDestination, $event)"
                    [disabled]="forcePushingId === actionDestination.id">
              <span class="action-icon action-icon--refresh" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <path d="M4 11a6 6 0 0 0 10 4" />
                  <path d="M16 9a6 6 0 0 0-10-4" />
                  <path d="M4 15v-4h4" />
                  <path d="M12 5h4v4" />
                </svg>
              </span>
              <span>
                {{ forcePushingId === actionDestination.id
                    ? ('audiences.actions.quick.processing' | translate)
                    : ('audiences.destinations.forcePush' | translate) }}
              </span>
            </button>
          </div>
        </ng-container>
      </ng-container>

      <ng-template #emptyState>
        <div class="empty-detail">
          <div class="icon">◎</div>
          <p>{{ 'audiences.details.empty' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </section>

  <section class="create-wrapper" *ngIf="mode === 'create' && canCreateAudience">
    <div class="obsolete-filters-banner" *ngIf="obsoleteFiltersInEdit.length > 0">
      <span class="obsolete-filters-icon">⚠</span>
      <span [innerHTML]="'audiences.actions.obsoleteFiltersAlert' | translate: { filters: obsoleteFiltersDisplayLabel }"></span>
    </div>
    <app-audience-create
      [ruleAudienceOptions]="ruleAudienceOptionsForForm"
      [customImportOptions]="customImportOptions"
      [sourceGroupOptions]="sourceGroupOptions"
      [optionsReady]="optionsReady"
      [skipDcrRuleFilters]="shouldSkipDcrRuleFilters"
      [mode]="creationMode"
      [initialValue]="createInitialValue"
      [countryOptions]="countryOptions"
      [submitting]="creatingAudience"
      [previewing]="previewingAudience"
      [hasObsoleteFilters]="obsoleteFiltersInEdit.length > 0"
      [isTNCDataEntity]="isTNCDataEntityForCreation"
      [isEntityTNCIDPlusMember]="isEntityTNCIDPlusMember"
      [canMakePublic]="canMakePublicAudience"
      [ownerInfo]="createFormOwnerInfo"
      (cancel)="onCreateCanceled()"
      (preview)="onAudiencePreviewRequested($event)"
      (save)="onAudienceSaved($event)"
      (expandVersionChange)="onExpandVersionChanged($event)"
      (staleItemsDetected)="onStaleItemsDetected()"
    ></app-audience-create>
    <p class="form-error" *ngIf="creationError">{{ creationError }}</p>
  </section>

  <div class="modal-backdrop" *ngIf="overlapModalOpen">
    <div class="modal-card overlap-modal surface-card" role="dialog" aria-modal="true">
      <header class="modal-header">
        <div>
          <h3>{{ 'audiences.actions.quick.overlap' | translate }}</h3>
          <p *ngIf="overlapSourceAudienceId && selectedAudience && overlapSourceAudienceId === selectedAudience.id">
            {{ 'audiences.overlap.source' | translate:{ name: selectedAudience.name } }}
          </p>
        </div>
        <button type="button" class="ghost-btn compact" aria-label="{{ 'audiences.actions.cancel' | translate }}" (click)="closeOverlapModal()">×</button>
      </header>
      <section class="overlap-modal__body">
        <p class="overlap-status" *ngIf="overlapLoadingId === overlapSourceAudienceId">
          {{ 'audiences.overlap.loading' | translate }}
        </p>
        <ng-container *ngIf="overlapLoadingId !== overlapSourceAudienceId">
          <div class="modal-search">
            <input type="search"
                   [placeholder]="'audiences.overlap.searchPlaceholder' | translate"
                   [(ngModel)]="overlapSearch">
          </div>
          <div class="overlap-toolbar" *ngIf="overlapResults.length">
            <span class="overlap-count">
              {{ 'audiences.overlap.resultsCount' | translate:{ count: filteredOverlapResults.length } }}
            </span>
            <div class="overlap-sort">
              <span class="overlap-sort__label">{{ 'audiences.overlap.sortBy' | translate }}</span>
              <button type="button" class="overlap-sort__btn"
                      [class.active]="overlapSortColumn === 'owner'"
                      (click)="setOverlapSort('owner')">
                {{ 'audiences.overlap.owner' | translate }}
                <span class="overlap-sort__dir" *ngIf="overlapSortColumn === 'owner'">{{ overlapSortDirection === 'asc' ? '▲' : '▼' }}</span>
              </button>
              <button type="button" class="overlap-sort__btn"
                      [class.active]="overlapSortColumn === 'tncIds'"
                      (click)="setOverlapSort('tncIds')">
                {{ 'audiences.overlap.tncids' | translate }}
                <span class="overlap-sort__dir" *ngIf="overlapSortColumn === 'tncIds'">{{ overlapSortDirection === 'asc' ? '▲' : '▼' }}</span>
              </button>
              <button type="button" class="overlap-sort__btn"
                      [class.active]="overlapSortColumn === 'targetOverlap'"
                      (click)="setOverlapSort('targetOverlap')">
                {{ 'audiences.overlap.targetShare' | translate }}
                <span class="overlap-sort__dir" *ngIf="overlapSortColumn === 'targetOverlap'">{{ overlapSortDirection === 'asc' ? '▲' : '▼' }}</span>
              </button>
              <button type="button" class="overlap-sort__btn"
                      [class.active]="overlapSortColumn === 'name'"
                      (click)="setOverlapSort('name')">
                {{ 'audiences.overlap.nameLabel' | translate }}
                <span class="overlap-sort__dir" *ngIf="overlapSortColumn === 'name'">{{ overlapSortDirection === 'asc' ? '▲' : '▼' }}</span>
              </button>
            </div>
          </div>
          <div class="overlap-list" *ngIf="filteredOverlapResults.length; else overlapModalEmpty">
            <div class="overlap-row" *ngFor="let overlap of filteredOverlapResults">
              <div class="overlap-owner">
                <label>{{ 'audiences.overlap.owner' | translate }}</label>
                <span [title]="overlap.targetOwnerLabel">{{ overlap.targetOwnerLabel }}</span>
              </div>
              <div class="overlap-name">
                <label>{{ 'audiences.overlap.target' | translate }}</label>
                <span [title]="overlap.targetAudienceName">{{ overlap.targetAudienceName }}</span>
              </div>
              <div>
                <label>{{ 'audiences.overlap.tncids' | translate }}</label>
                <span>{{ overlap.tncIds | number }}</span>
              </div>
              <!-- Source overlap section commented out -->
              <!--
              <div>
                <label>{{ 'audiences.overlap.sourceShare' | translate }}</label>
                <span>{{ (overlap.sourceOverlap || 0) | percent:'1.0-2' }}</span>
                <div class="overlap-progress">
                  <div class="overlap-progress__bar">
                    <div class="overlap-progress__fill" [style.width.%]="getOverlapPercent(overlap.sourceOverlap)"></div>
                  </div>
                </div>
              </div>
              -->
              <div>
                <label>{{ 'audiences.overlap.targetShare' | translate }}</label>
                <span>{{ (overlap.targetOverlap || 0) | percent:'1.0-2' }}</span>
              </div>
            </div>
          </div>
          <ng-template #overlapModalEmpty>
            <p class="overlap-status">{{ 'audiences.overlap.empty' | translate }}</p>
          </ng-template>
        </ng-container>
      </section>
      <footer class="modal-actions">
        <button type="button" class="primary-btn" (click)="closeOverlapModal()">
          {{ 'audiences.actions.close' | translate }}
        </button>
      </footer>
    </div>
  </div>

  <div class="modal-backdrop" *ngIf="deleteModalOpen">
    <div class="modal-card confirmation-modal surface-card" role="dialog" aria-modal="true">
      <header class="modal-header">
        <div>
          <h3>{{ 'audiences.actions.quick.delete' | translate }}</h3>
          <p>{{ 'audiences.actions.deleteConfirmMessage' | translate:{ name: deleteTargetAudience?.name } }}</p>
        </div>
        <button type="button" class="ghost-btn compact" aria-label="{{ 'audiences.actions.cancel' | translate }}" (click)="closeDeleteModal()">×</button>
      </header>
      <footer class="modal-actions">
        <button type="button" class="ghost-btn" (click)="closeDeleteModal()">
          {{ 'audiences.actions.cancel' | translate }}
        </button>
        <button type="button"
                class="primary-btn danger"
                (click)="performDelete()"
                [disabled]="!canManageAudienceActions || deletingAudienceId === deleteTargetAudience?.id">
          {{ deletingAudienceId === deleteTargetAudience?.id
              ? ('audiences.actions.processing' | translate)
              : ('audiences.actions.delete' | translate) }}
        </button>
      </footer>
    </div>
  </div>
  <div class="filter-dropdown surface-card"
       *ngIf="ownerFilterOpen && isOwnerFilterEnabled"
       [style.top.px]="ownerFilterPosition.top"
       [style.left.px]="ownerFilterPosition.left">
    <div class="filter-panel-header">
      <strong>{{ 'audiences.listFilters.owner.title' | translate }}</strong>
      <button type="button"
              class="ghost-btn compact"
              *ngIf="selectedOwnerIds.size > 0"
              (click)="clearOwnerFilter()">
        {{ 'audiences.listFilters.owner.clearSelection' | translate }}
      </button>
    </div>
    <div class="filter-panel-search">
      <input type="search"
             [(ngModel)]="ownerFilterSearch"
             [placeholder]="'audiences.listFilters.owner.searchPlaceholder' | translate"
             [attr.aria-label]="'audiences.listFilters.owner.searchPlaceholder' | translate">
    </div>
    <div class="filter-panel-sort">
      <span>{{ 'audiences.listFilters.owner.sortLabel' | translate }}</span>
      <button type="button"
              class="filter-panel-sort__option"
              [class.is-active]="ownerFilterSortBy === 'name'"
              (click)="setOwnerFilterSort('name')">
        {{ 'audiences.listFilters.owner.sortByName' | translate }}
        <small *ngIf="ownerFilterSortBy === 'name'">{{ ownerFilterSortDirection === 'asc' ? '↑' : '↓' }}</small>
      </button>
      <button type="button"
              class="filter-panel-sort__option"
              [class.is-active]="ownerFilterSortBy === 'count'"
              (click)="setOwnerFilterSort('count')">
        {{ 'audiences.listFilters.owner.sortByCount' | translate }}
        <small *ngIf="ownerFilterSortBy === 'count'">{{ ownerFilterSortDirection === 'asc' ? '↑' : '↓' }}</small>
      </button>
    </div>
    <div class="filter-panel-body">
      <label *ngFor="let owner of filteredOwnerFilterOptions" class="status-filter-option">
        <input type="checkbox"
               [checked]="selectedOwnerIds.has(owner.id)"
               (change)="toggleOwnerFilterOption(owner.id)">
        <span class="status-filter-option__label" [title]="owner.label">{{ owner.label }}</span>
        <span class="status-filter-option__count">{{ owner.count }}</span>
      </label>
      <p class="filter-panel-empty" *ngIf="!filteredOwnerFilterOptions.length">
        {{ 'audiences.listFilters.owner.empty' | translate }}
      </p>
    </div>
  </div>
  <div class="filter-dropdown extraction-date-dropdown surface-card"
       *ngIf="extractionDateFilterOpen && isExtractionDateFilterEnabled"
       [style.top.px]="extractionDateFilterPosition.top"
       [style.left.px]="extractionDateFilterPosition.left">
    <div class="filter-panel-header">
      <strong>{{ 'audiences.listFilters.extractionDate.title' | translate }}</strong>
      <button type="button"
              class="ghost-btn compact"
              *ngIf="selectedExtractionDate"
              (click)="clearExtractionDateFilter()">
        {{ 'audiences.listFilters.extractionDate.clear' | translate }}
      </button>
    </div>
    <app-extraction-date-calendar
      [selected]="selectedExtractionDate"
      [locale]="calendarLocale"
      [prevLabel]="'audiences.listFilters.extractionDate.prevMonth' | translate"
      [nextLabel]="'audiences.listFilters.extractionDate.nextMonth' | translate"
      (selectedChange)="selectExtractionDate($event)">
    </app-extraction-date-calendar>
    <div class="filter-panel-sort extraction-date-kind" *ngIf="selectedExtractionDate && isExtractionDateToday">
      <button type="button"
              class="filter-panel-sort__option"
              [class.is-active]="extractionDateKind === 'all'"
              (click)="setExtractionDateKind('all')">
        {{ 'audiences.listFilters.extractionDate.kindAll' | translate }}
      </button>
      <button type="button"
              class="filter-panel-sort__option"
              [class.is-active]="extractionDateKind === 'done'"
              (click)="setExtractionDateKind('done')">
        {{ 'audiences.listFilters.extractionDate.kindDone' | translate }}
      </button>
      <button type="button"
              class="filter-panel-sort__option"
              [class.is-active]="extractionDateKind === 'planned'"
              (click)="setExtractionDateKind('planned')">
        {{ 'audiences.listFilters.extractionDate.kindPlanned' | translate }}
      </button>
    </div>
    <p class="filter-panel-empty">
      <ng-container *ngIf="!selectedExtractionDate">{{ 'audiences.listFilters.extractionDate.hint' | translate }}</ng-container>
      <ng-container *ngIf="selectedExtractionDate && extractionDateLoading">{{ 'audiences.listFilters.extractionDate.loading' | translate }}</ng-container>
      <ng-container *ngIf="selectedExtractionDate && !extractionDateLoading && extractionDateError">{{ 'audiences.listFilters.extractionDate.error' | translate }}</ng-container>
      <ng-container *ngIf="selectedExtractionDate && !extractionDateLoading && !extractionDateError">{{ extractionDateSummary }}</ng-container>
    </p>
  </div>

  </section>
</main>
  <div class="modal-backdrop" *ngIf="statusModalOpen">
    <div class="modal-card confirmation-modal surface-card" role="dialog" aria-modal="true">
      <header class="modal-header">
        <div>
          <h3>{{ statusModalTarget?.status === 'active'
            ? ('audiences.actions.quick.pause' | translate)
            : ('audiences.actions.quick.resume' | translate) }}</h3>
          <p>{{ statusModalTarget?.status === 'active'
            ? ('audiences.actions.pauseConfirmMessage' | translate:{ name: statusModalTarget?.name })
            : ('audiences.actions.resumeConfirmMessage' | translate:{ name: statusModalTarget?.name }) }}</p>
        </div>
        <button type="button" class="ghost-btn compact" aria-label="{{ 'audiences.actions.cancel' | translate }}" (click)="closeStatusModal()">×</button>
      </header>
      <footer class="modal-actions">
        <button type="button" class="ghost-btn" (click)="closeStatusModal()">
          {{ 'audiences.actions.cancel' | translate }}
        </button>
        <button type="button"
                class="primary-btn"
                (click)="performToggleStatus()"
                [disabled]="!canManageAudienceActions || statusUpdatingId === statusModalTarget?.id">
          {{ statusUpdatingId === statusModalTarget?.id
              ? ('audiences.actions.processing' | translate)
              : statusModalTarget?.status === 'active'
              ? ('audiences.actions.pauseConfirmButton' | translate)
              : ('audiences.actions.resumeConfirmButton' | translate) }}
        </button>
      </footer>
    </div>
  </div>

  <div class="modal-backdrop" *ngIf="forcePushModalOpen">
    <div class="modal-card confirmation-modal surface-card" role="dialog" aria-modal="true">
      <header class="modal-header">
        <div>
          <h3>{{ 'audiences.destinations.forcePushConfirmTitle' | translate }}</h3>
          <p>{{ 'audiences.destinations.forcePushConfirmMessage' | translate:{ audienceName: selectedAudience?.name, destinationName: forcePushModalTarget?.name } }}</p>
        </div>
        <button type="button" class="ghost-btn compact" aria-label="{{ 'audiences.actions.cancel' | translate }}" (click)="closeForcePushModal()">×</button>
      </header>
      <footer class="modal-actions">
        <button type="button" class="ghost-btn" (click)="closeForcePushModal()">
          {{ 'audiences.actions.cancel' | translate }}
        </button>
        <button type="button"
                class="primary-btn"
                (click)="performForcePush()"
                [disabled]="forcePushingId === forcePushModalTarget?.id">
          {{ forcePushingId === forcePushModalTarget?.id
              ? ('audiences.actions.quick.processing' | translate)
              : ('audiences.destinations.forcePushConfirmButton' | translate) }}
        </button>
      </footer>
    </div>
  </div>

  <div class="modal-backdrop" *ngIf="stopModalOpen">
    <div class="modal-card confirmation-modal surface-card" role="dialog" aria-modal="true">
      <header class="modal-header">
        <div>
          <h3>{{ 'audiences.destinations.stopConfirmTitle' | translate }}</h3>
          <p>{{ 'audiences.destinations.stopConfirmMessage' | translate:{ destinationName: stopModalTarget?.name } }}</p>
        </div>
        <button type="button" class="ghost-btn compact" aria-label="{{ 'audiences.actions.cancel' | translate }}" (click)="closeStopModal()">×</button>
      </header>
      <footer class="modal-actions">
        <button type="button"
                class="ghost-btn"
                (click)="performStopOnly()"
                [disabled]="activationStatusUpdatingId === stopModalTarget?.id">
          {{ activationStatusUpdatingId === stopModalTarget?.id
              ? ('audiences.actions.quick.processing' | translate)
              : ('audiences.destinations.stopOnlyButton' | translate) }}
        </button>
        <button type="button"
                class="primary-btn danger"
                (click)="performStopAndRemove()"
                [disabled]="removingActivationId === stopModalTarget?.id">
          {{ removingActivationId === stopModalTarget?.id
              ? ('audiences.actions.quick.processing' | translate)
              : ('audiences.destinations.stopAndRemoveButton' | translate) }}
        </button>
      </footer>
    </div>
  </div>
